import React, { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";

/**
 * OrientationGate — Portrait-only lock overlay.
 * Shows a fullscreen overlay when a touch device (<=1024px) is held in landscape.
 * Does NOT interfere with desktop monitors (width > 1024px remain unaffected).
 */
export default function OrientationGate() {
  const check = () => {
    if (typeof window === "undefined") return false;
    const narrow = window.innerWidth <= 1024;
    const landscape = window.matchMedia("(orientation: landscape)").matches;
    return narrow && landscape;
  };

  const [shouldBlock, setShouldBlock] = useState(check);

  useEffect(() => {
    const update = () => setShouldBlock(check());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    const mql = window.matchMedia("(orientation: landscape)");
    const mqlHandler = () => update();
    if (mql.addEventListener) mql.addEventListener("change", mqlHandler);
    else if (mql.addListener) mql.addListener(mqlHandler);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      if (mql.removeEventListener) mql.removeEventListener("change", mqlHandler);
      else if (mql.removeListener) mql.removeListener(mqlHandler);
    };
  }, []);

  if (!shouldBlock) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] bg-background/95 backdrop-blur-xl flex items-center justify-center p-6"
      data-testid="orientation-gate"
      role="alertdialog"
      aria-live="polite"
    >
      <div className="max-w-[380px] w-full text-center flex flex-col items-center gap-5">
        <div className="relative w-20 h-20 rounded-2xl bg-lavender-100 dark:bg-lavender-900/40 flex items-center justify-center">
          <Smartphone
            className="w-10 h-10 text-lavender-600 dark:text-lavender-300 orientation-gate-rotate"
            strokeWidth={1.75}
          />
        </div>
        <h2 className="font-display text-2xl tracking-tight font-semibold text-foreground">
          Ruota il dispositivo
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          IH AuditFlow è ottimizzato per l'uso verticale.<br />
          Ruota il tuo telefono o tablet in modalità portrait per continuare.
        </p>
      </div>
      <style>{`
        @keyframes ih-rotate-hint {
          0%, 100% { transform: rotate(-90deg); }
          40%, 60% { transform: rotate(0deg); }
        }
        .orientation-gate-rotate {
          animation: ih-rotate-hint 2.4s ease-in-out infinite;
          transform-origin: center;
        }
      `}</style>
    </div>
  );
}
